























import { Vue, Component } from 'vue-property-decorator'
@Component({
  apollo: {
    post: {
      query: require('~base/graphql/queries/KleineArticles.gql'),
      variables() {
        return {
          post_slug: this.$route.params.post_slug.replace(/\.neue$/, ''),
        }
      },
      prefetch: ({ route }: any) => ({
        post_slug: route.params.post_slug.replace(/\.neue$/, ''),
      }),
    },
  },
})
export default class KleineArticles extends Vue {}
